import dayjs from 'dayjs'
import i18n, { Resource } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

i18n.use(LanguageDetector).use(initReactI18next)

export const resources: Resource = {}

export function getActiveResource(): Record<string, string> | undefined {
  for (const lng of Object.keys(resources)) {
    const r = (resources[lng] as { translation?: Record<string, string> })?.translation
    if (r) return r
  }
  return undefined
}

export async function loadTranslations() {
  let lng: string = 'en'

  const inline = window.hallway.universe.translations
  if (inline) {
    if (inline._lng) lng = inline._lng
    resources[lng] = { translation: inline }
  } else {
    const url = window.hallway.universe.translationsURL
    if (url) {
      try {
        const res = await fetch(url)
        const translations: Record<string, string> = await res.json()
        if (translations._lng) lng = translations._lng
        resources[lng] = { translation: translations }
      } catch (e) {
        console.error('failed to load translations', e)
      }
    }
  }

  await i18n.init({
    lng,
    resources,
    interpolation: { escapeValue: false },
    fallbackLng: false, // the key is the fallback
    nsSeparator: false,
    keySeparator: false // allow keys to be phrases having ':' and '.' (as we don't use namespaces etc)
  })

  i18n.services.formatter?.add('date', (timestamp: number, lng: string | undefined) => {
    switch (lng) {
      case 'zh':
      case 'ja':
        return dayjs(timestamp).format('YYYY年MM月DD日')
      case 'pl':
      case 'de':
      case 'ru':
        return dayjs(timestamp).format('DD.MM.YYYY')
      case 'fa':
        return dayjs(timestamp).format('YYYY/MM/DD')
      case 'it':
      case 'es':
      case 'fr':
      case 'pt-BR':
      case 'pt-PT':
      case 'ar':
      case 'hi':
      case 'th':
        return dayjs(timestamp).format('DD/MM/YYYY')
      case 'ko':
        return dayjs(timestamp).format('YYYY년 MM월 DD일')
      default:
        return dayjs(timestamp).format('MMM D, YYYY')
    }
  })
}
